// import { ParentRelation } from '@shared/interfaces';
import { uniqueArrayItems } from './tools';

// export const mergeParentIds = <T>(data: T | T[], current: T[]): T[] => {
//     const parentIds = !current ? [] : (Array.isArray(current) ? current : [current]);
//     if (data === null || data === undefined) {
//         return parentIds;
//     }

//     const passed = Array.isArray(data) ? data : [data];
//     return [...parentIds, ...passed].filter(uniqueArrayItems);
// };

// export const extendElementByParentId = <T, ID>(data: T & ParentRelation<ID>, id: ID | ID[]): T & ParentRelation<ID> => {
//     if (!data || id === null || id === undefined) {
//         return data;
//     }

//     const element = {...data};
//     element._parentIds = mergeParentIds(id, element._parentIds);
//     return element;
// };

// export const extendElementsByParentId = <T, ID>(data: Array<T & ParentRelation<ID>>, id: ID | ID[]): Array<T & ParentRelation<ID>> => {
//     if (!data || !data.length || id === null || id === undefined || (Array.isArray(id) && !id.length)) {
//         return data;
//     }

//     return [...data].map(element => ({
//         ...element,
//         _parentIds: mergeParentIds(id, element._parentIds)
//     }));
// };
